@if (loading) {
  <app-loading />
}

@if (!loading) {
  <div class="flex flex-col justify-center items-center overflow-hidden h-screen w-screen">
    @if (hasError) {
      <div class="flex flex-col justify-center items-center gap-4">
        <app-logo class="w-[200px] animate-wiggle" ></app-logo>
        <h1 class="text-2xl font-termina">Could not validate your email address</h1>
        <a class="text-md text-cyan-700 hover:underline mont-montserrat" href="">Go home</a>
      </div>
    }
    @if (!hasError) {
      <div class="flex flex-col justify-center items-center gap-4">
        <app-logo class="w-[200px] animate-wiggle"></app-logo>
        <h1 class="text-2xl font-termina">Success! Your email address was verified</h1>
        <a class="text-md text-cyan-700 hover:underline font-montserrat" href="">Go home</a>
      </div>
    }
  </div>
}
